import SftpItemForm from "../Layout/sftp/SftpItemForm";
import SftpChooseAccount from "../Layout/stepUtils/SftpChooseAccount";

const SFTP_COMMON = [
  {
    title: "Choosed Account",
    content: () => <SftpChooseAccount />,
  },
];

const SFTP_NEW_CONTACT = {
  steps: [
    ...SFTP_COMMON,
    {
      title: "Customize Record",
      content: () => <SftpItemForm />,
    },
  ],
};

const SFTP_NEW_ITEM = {
  steps: [
    ...SFTP_COMMON,
    {
      title: "Customize Record",
      content: () => <SftpItemForm />,
    },
  ],
};

export { SFTP_NEW_CONTACT, SFTP_NEW_ITEM };
